import { localize } from "@/i18n/translate";
import { useLocation, useNavigate } from "react-router-dom";
import { scrollToId } from "@/lib/scroll";
export const SectionLink = ({
  to,
  children,
  onNavigate,
  onBefore,
  ...rest
}) => {
  const navigate = useNavigate();
  const {
    pathname
  } = useLocation();
  const onClick = e => {
    e.preventDefault();
    onBefore?.();
    if (pathname !== "/") {
      onNavigate?.();
      navigate(`/#${to}`);
      return;
    }
    window.history.replaceState(null, "", `#${to}`);
    if (onNavigate) {
      onNavigate();
      setTimeout(() => scrollToId(to), 350);
    } else {
      scrollToId(to);
    }
  };
  return <a href={`/#${to}`} onClick={onClick} {...rest}>
      {localize(children)}
    </a>;
};
